import React from "react";
import { motion } from "framer-motion";
import { AiOutlineMail } from "react-icons/ai";
import { FaLinkedin } from "react-icons/fa";

const Contact = () => {
  return (
    <motion.div
      className="app__contact"
      id="contact"
      whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <div className="projects__heading-text">
        <h2 className="head-text">
          <span className="p-ctext">#</span>Contacts
        </h2>
        <div className="horizontal-line"></div>
      </div>

      <div className="app__contact-container">
        <div className="contact__msg-text">
          <p>
            I’m interested in freelance opportunities. However, if you have
            other request or question, don’t hesitate to contact me
          </p>
        </div>

        <div className="contact__msg-platform">
          <p className="p-btext">Message me here</p>

          <a href="www.linkedin.com/in/urch-ezedinma-3b4451295">
            <FaLinkedin /> <span> Linkedin</span>
          </a>
          <a href="mailto:mysviurch@gmail.com">
            <AiOutlineMail /> <span> mysviurch@gmail.com</span>
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default Contact;
